module.exports = {
	"id": "SE",
	"name": "Sweden",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.006012,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.012024,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.018036,
			"23": null,
			"24": null,
			"25": 0.006012,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.012024,
			"30": null,
			"31": 0.1503,
			"32": 0.006012,
			"33": 0.018036,
			"34": 0.03006,
			"35": 0.03006,
			"36": 0.012024,
			"37": 0.018036,
			"38": 0.03006,
			"39": 0.108216,
			"40": 0.03006,
			"41": 0.018036,
			"42": 0.018036,
			"43": 0.072144,
			"44": 0.042084,
			"45": 0.042084,
			"46": 0.054108,
			"47": 0.048096,
			"48": 0.084168,
			"49": 1.136268,
			"50": 0.126252,
			"51": 0.498996,
			"52": 0.667332,
			"53": 23.65722,
			"54": 5.392764,
			"55": 0.048096,
			"56": 0.012024,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.012024,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.006012,
			"17": 0.012024,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": 0.006012,
			"24": 0.006012,
			"25": null,
			"26": 0.012024,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.012024,
			"32": null,
			"33": 0.006012,
			"34": 0.072144,
			"35": 0.012024,
			"36": 0.006012,
			"37": 0.024048,
			"38": 0.054108,
			"39": 0.018036,
			"40": 0.018036,
			"41": 0.018036,
			"42": 0.03006,
			"43": 0.066132,
			"44": 0.03006,
			"45": 0.198396,
			"46": 0.078156,
			"47": 0.306612,
			"48": 0.474948,
			"49": 5.825628,
			"50": 0.042084,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.012024
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.006012,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.012024,
			"37": 0.018036,
			"38": 0.036072,
			"39": 0.006012,
			"40": 0.276552,
			"41": 0.042084,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.036072
		},
		"safari": {
			"0": null,
			"4": 0.006012,
			"5": 0.036072,
			"6": 0.018036,
			"7": 0.096192,
			"8": 0.51102,
			"9": 0.63126,
			"10": 2.452896,
			"3.1": null,
			"3.2": null,
			"5.1": 0.108216,
			"6.1": 0.186372,
			"7.1": 0.024048,
			"9.1": 1.86372
		},
		"ios_saf": {
			"8": 0,
			"10": 13.9144474538,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.374978258118,
			"8.1-8.4": 0.692756442964,
			"9.0-9.2": 0.33048931224,
			"9.3": 5.04208053289
		},
		"android": {
			"3": 0,
			"4": 0.0166630387597,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00208287984496,
			"4.1": 0.0601059612403,
			"4.2-4.3": 0.150264903101,
			"4.4": 0.344567837209,
			"4.4.3-4.4.4": 0.347543379845
		},
		"ie": {
			"6": null,
			"7": 0.0120492605042,
			"8": 0.11446797479,
			"9": 0.265083731092,
			"10": 0.283157621849,
			"11": 7.91033952101,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00770064481739,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000213906800483
		},
		"edge": {
			"12": 0.096192,
			"13": 0.769536,
			"14": 2.771532
		},
		"ie_mob": {
			"10": 0.0456092394366,
			"11": 0.185694760563
		},
		"bb": {
			"7": 0.002991,
			"10": null
		},
		"samsung": {
			"0": 4.893276
		},
		"and_uc": {
			"0": 0.063808
		},
		"op_mini": {
			"0": 0.103749448382
		},
		"and_chr": {
			"0": 13.886308
		},
		"and_ff": {
			"0": 0.043868
		}
	},
	"total": 98.8616331092
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SE.json
 ** module id = 641
 ** module chunks = 0
 **/